module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header', {
    staticClass: "main-content--header"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column left"
  }, [_c('router-link', {
    staticClass: "router-link-active",
    attrs: {
      "to": "/admin"
    }
  }, [_c('h4', [_vm._v("Admin Reports")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "column right"
  }, [_c('router-link', {
    staticClass: "router-link-active",
    attrs: {
      "to": "/admin/settings"
    }
  }, [_vm._v("\n          Go to Admin Settings\n        ")])], 1)])]), _vm._v(" "), _c('section', {
    staticClass: "main-content--body"
  }, [_c('div', {
    staticClass: "wrapper-md"
  }, [_c('div', {
    staticClass: "main-content--panel"
  }, [_c('div', {
    staticClass: "panel--top"
  }, [_c('h3', [_vm._v("Worklogs Users")]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "loading-icon"
  }, [_c('span', {
    staticClass: "slack-loader"
  })]) : _vm._e(), _vm._v(" "), (_vm.users) ? _c('div', {
    staticClass: "users--table"
  }, [_c('table', [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.users), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.email))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.date))]), _vm._v(" "), _c('td', [_c('router-link', {
      staticClass: "button is-primary is-medium kuzco-green",
      attrs: {
        "to": {
          name: 'User',
          params: {
            id: item.id
          }
        }
      }
    }, [_vm._v("View")])], 1)])
  }))])]) : _vm._e()])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Email")]), _vm._v(" "), _c('th', [_vm._v("Date Joined")]), _vm._v(" "), _c('th', [_vm._v("Reports")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0eea033c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin.vue
// module id = 378
// module chunks = 1